module.exports = __webpack_public_path__ + "img/a3.84f014f0.jpg";